<template>
  <div>
    <form ref="partnerDetailsRef">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="form-group">
            <label for="companyName">{{ $t("partner") }}</label>
            <select
              v-model="partner"
              name="partner"
              class="form-control"
              id="partner"
              required
            >
              <option value="">{{ $t("select-partner") }}</option>

              <option value="newPartner" v-if="newPartner">
                {{ newPartner }}
              </option>

              <option
                v-for="partner in partners"
                :key="partner.id"
                :value="partner.id"
              >
                {{ partner.name }}
              </option>
            </select>

            <div class="font-12 gray4 mt-2">
              Partner not listed?
              <span
                class="text-primary cursor-pointer"
                @click="$emit('open_add_partner')"
                >Add New Partner</span
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  name: "PartnerDetailsStep",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    partnerObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      partner: this.initialValues?.partner ?? "", // Initialize with the partner from props
      newPartner: null, // New partner name
    };
  },
  methods: {
    validateForm() {
      const form = this.$refs.partnerDetailsRef;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        partner: this.partner, // Return the selected partner or new partner
      };
    },
  },
  watch: {
    initialValues: {
      handler(newValues) {
        this.partner = newValues.partner || "";
      },
      deep: true,
    },
    partnerObj: {
      handler(partner) {
        if (partner.name) {
          this.newPartner = partner.name;

          this.partner = "newPartner";
        }
      },
    },
  },
  computed: {
    ...mapGetters(["partners"]),
  },
};

</script>

